<div class="bp-modal-body">
  <div class="progress progress-thin mb-0">
    <div
      class="progress-bar"
      role="progressbar"
      [style.width.%]="getVerificationProgress() * 15"
      [attr.aria-valuenow]="getVerificationProgress()"
      aria-valuemin="1"
    aria-valuemax="4"></div>
  </div>
  <!-- Step 1: Terms and Camera permission: -->
  @if (isFirstStep()) {
    <div>
      <!-- Description -->
      <div class="verification-modal-step-description">
        <div class="max-w-550 center-block">
          <span class="font-size-20">{{ "eid_data_main_title" | translate }}</span>
        </div>
      </div>
      <!-- Terms sliders and biometric text -->
      @if (!hasAcceptedTerms()) {
        <verification-terms-modal
          (onAccept)="onTermsContinueClick()"
          [logoUrl]="logoUrl"
        [moreBiometricKey]="'onfido_data_biometric_content_2'"></verification-terms-modal>
      }
    </div>
  }
  <!-- Step 2: Browser not supported -->
  @if (isSecondStep()) {
    <div>
      <verification-browser-modal [incompatibilityType]="getIncompatibilityType()"></verification-browser-modal>
    </div>
  }
</div>
